import { Task } from '../types/task';

/**
 * 日期工具函数
 */

/**
 * 获取指定日期的任务
 */
export const filterTasksByDate = (tasks: Task[], date: Date): Task[] => {
  if (!tasks || tasks.length === 0) {
    return [];
  }
  
  // 获取当前日期的开始和结束时间
  const startOfDay = new Date(date);
  startOfDay.setHours(0, 0, 0, 0);
  
  const endOfDay = new Date(date);
  endOfDay.setHours(23, 59, 59, 999);
  
  // 筛选当前日期的任务
  return tasks.filter((task: Task) => {
    // 优先使用 startAt，如果没有则使用 dueAt
    const taskDate = task.startAt || task.dueAt;
    
    if (!taskDate) {
      // 没有时间的任务只在今天显示
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return startOfDay.getTime() === today.getTime();
    }
    
    const date = new Date(taskDate);
    return date >= startOfDay && date <= endOfDay;
  });
};

/**
 * 获取日期快速切换选项
 */
export const getQuickDateOptions = (currentDate: Date) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  
  const current = new Date(currentDate);
  current.setHours(0, 0, 0, 0);
  
  return {
    yesterday,
    today,
    tomorrow,
    isToday: current.getTime() === today.getTime(),
    isYesterday: current.getTime() === yesterday.getTime(),
    isTomorrow: current.getTime() === tomorrow.getTime()
  };
};

/**
 * 格式化日期显示
 */
export const formatDateDisplay = (date: Date, locale: string = 'zh'): string => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  
  const targetDate = new Date(date);
  targetDate.setHours(0, 0, 0, 0);
  
  const diffDays = Math.floor((targetDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) {
    return locale === 'zh' ? '今天' : 'Today';
  } else if (diffDays === -1) {
    return locale === 'zh' ? '昨天' : 'Yesterday';
  } else if (diffDays === 1) {
    return locale === 'zh' ? '明天' : 'Tomorrow';
  } else {
    // 显示具体日期
    if (locale === 'zh') {
      return date.toLocaleDateString('zh-CN', { 
        month: 'long', 
        day: 'numeric',
        weekday: 'short'
      });
    } else {
      return date.toLocaleDateString('en-US', { 
        month: 'short', 
        day: 'numeric',
        weekday: 'short'
      });
    }
  }
};

/**
 * 获取任务的显示时间
 */
export const getTaskDisplayTime = (task: Task): string => {
  const timeStr = task.startAt || task.dueAt;
  
  if (!timeStr) {
    return '';
  }
  
  const date = new Date(timeStr);
  
  // 如果有 cost，显示时长
  if (task.cost && task.cost > 0) {
    const minutes = Math.floor(task.cost / 60);
    const hours = Math.floor(minutes / 60);
    
    if (hours > 0) {
      const remainingMinutes = minutes % 60;
      return remainingMinutes > 0 ? `${hours}h ${remainingMinutes}m` : `${hours}h`;
    } else {
      return `${minutes}m`;
    }
  }
  
  // 否则显示时间点
  return date.toLocaleTimeString('zh-CN', { 
    hour: '2-digit', 
    minute: '2-digit',
    hour12: false
  });
};
